import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'tw-banner',
  standalone: true,
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent {
  private notifications = inject(NotificationService);
  readonly items = this.notifications.notifications;

  dismiss(id: number): void {
    this.notifications.dismiss(id);
  }
}
